import { Modules } from "../../common/data/constants";
import {decryptData} from "../../helpers/crypto_helper"


const getAccessRights = (pathname, history) => {
    // Step 1: Get Modules from localStorage 
    const storedModules = localStorage.getItem("modules");
    if (!storedModules) {
        history.push("/unAuthorized");
        return null;
    }

    let moduleList;
    try {
        const decryptedModules = decryptData(storedModules);
        moduleList = JSON.parse(decryptedModules);
    } catch (err) {
        console.error("Modules decryption error:", err);
        history.push("/unAuthorized");
        return null;
    }

    // Step 2: Find Current Module using pathname
    const currentModule = moduleList.find(m => m.module_route === pathname);
    if (!currentModule) {
        history.push("/unAuthorized");
        return null;
    }

    const moduleCode = currentModule.module_code;

    // Step 3: Get Access Rights from localStorage
    const accessRights = JSON.stringify(localStorage.getItem("accessRights"));
    if (!accessRights) {
        history.push("/unAuthorized");
        return null;
    }

    try {
        const decryptedData = decryptData(JSON.parse(accessRights));
        const accessModule = JSON.parse(decryptedData);

        const filteredData = accessModule.find(item => item.module_code === moduleCode);

        if (!filteredData) {
            history.push("/unAuthorized");
            return null;
        }

        const accessData = {
            module_code: filteredData.module_code,
            read_access: filteredData.read_access,
            create_access: filteredData.create_access,
            edit_access: filteredData.edit_access,
            delete_access: filteredData.delete_access,
            approve_access: filteredData.approve_access,
        };

        // Step 4: If no access granted → redirect
        if (
            accessData.read_access === 0 &&
            accessData.create_access === 0 &&
            accessData.edit_access === 0 &&
            accessData.delete_access === 0 &&
            accessData.approve_access === 0
        ) {
            history.push("/unAuthorized");
            return null;
        }

        return {
            data: accessData,
            status: "Success",
            message: "",
        };

    } catch (error) {
        console.error("Access Rights Decryption Error:", error);
        history.push("/unAuthorized");
        return null;
    }
};

export default getAccessRights;

// const getAccessRights = (pathname,history) => {
//     // Step 1: Get Module Code by Route
//     const currentModule = Modules.find(module => module.module_route === pathname);
//     if (!currentModule) {
//         history.push("/unAuthorized");
//         return null;
//     }

//     const moduleCode = currentModule.module_code;

//     const accessRights = JSON.stringify(localStorage.getItem("accessRights"));
//     if (!accessRights) {
//         history.push("/unAuthorized");
//         return null;
//     }

//     try {
//         const decryptedData = decryptData(JSON.parse(accessRights));
//         const accessModule = JSON.parse(decryptedData);

//         const filteredData = accessModule.find(item => item.module_code === moduleCode);

//         if (!filteredData) {
//             history.push("/unAuthorized");
//             return null;
//         }

//         const accessData = {
//             module_code: filteredData.module_code,
//             read_access: filteredData.read_access,
//             create_access: filteredData.create_access,
//             edit_access: filteredData.edit_access,
//             delete_access: filteredData.delete_access,
//             approve_access: filteredData.approve_access,
//         };

//         // Step 3: Redirect if No Access
//         if (
//             accessData.read_access === 0 &&
//             accessData.create_access === 0 &&
//             accessData.edit_access === 0 &&
//             accessData.delete_access === 0 &&
//             accessData.approve_access === 0
//         ) {
//             history.push("/unAuthorized");
//             return null;
//         }

//         return {
//             data: accessData,
//             status: 'Success',
//             message: ''
//         };
//     } catch (error) {
//         console.error("Decryption error:", error);
//         history.push("/unAuthorized");
//         return null;
//     }
// };

// export default getAccessRights;


// import { Modules } from "../../common/data/constants";
// import { decryptData } from "../../helpers/crypto_helper";

// const getAccessRights = (pathname) => {
//     // 1. Match route (exact OR partial)
//     const currentModule = Modules.find(module => 
//         pathname.startsWith(module.module_route)
//     );

//     if (!currentModule) return null;

//     const moduleCode = currentModule.module_code;

//     // 2. Get accessRights from storage
//     const accessRights = localStorage.getItem("accessRights");
//     if (!accessRights) return null;

//     try {
//         const decryptedData = decryptData(JSON.parse(accessRights));
//         const accessModule = JSON.parse(decryptedData);

//         // 3. Check module access
//         const filteredData = accessModule.find(item => item.module_code === moduleCode);
//         if (!filteredData) return null;

//         const accessData = {
//             module_code: filteredData.module_code,
//             read_access: filteredData.read_access,
//             create_access: filteredData.create_access,
//             edit_access: filteredData.edit_access,
//             delete_access: filteredData.delete_access,
//         };

//         // 4. Reject if all permissions are 0
//         const hasAnyAccess =
//             accessData.read_access ||
//             accessData.create_access ||
//             accessData.edit_access ||
//             accessData.delete_access;

//         if (!hasAnyAccess) return null;

//         return {
//             data: accessData,
//             status: "Success"
//         };

//     } catch (error) {
//         console.error("Decryption error:", error);
//         return null;
//     }
// };

// export default getAccessRights;
